import { useContext } from "react";
import SearchBar from "../../../components/searchBar/SearchBar.jsx";
import ImageSlider from "../../../components/basicslider/ImageSlider.jsx";
import { AuthContext } from "../../../context/AuthContext.jsx"; // Ensure this path is correct
import "./homePage.scss";
// import bg from "../../assets/bg.png";

// bhoomi banner ad images
import img008 from '../../../assets/random_res/008.jpg';
import img012 from '../../../assets/random_res/012.jpg';
import img026 from '../../../assets/random_res/026.jpg';
import img030 from '../../../assets/random_res/030.jpg';
// import img035 from '../../assets/random_res/035.jpg';
// import img036 from '../../assets/random_res/036.jpg';
// import img040 from '../../assets/random_res/040.jpg';
// import img045 from '../../assets/random_res/045.jpg';
// import img047 from '../../assets/random_res/047.jpg';


// space banner ad images
import space1 from "../../../assets/ads/space/banner/1.png";
import space2 from "../../../assets/ads/space/banner/2.png";
import space3 from "../../../assets/ads/space/banner/3.png";
import space4 from "../../../assets/ads/space/banner/4.png";
// import spacevideo from "../../assets/ads/space/banner/spacehomebanner.mp4";


function HomePage() {

  const { currentUser } = useContext(AuthContext);
  // we are using our custom authcontext, 
  // our variable current user is gett extracted from authcontext i.e localstorate

  // console.log(currentUser);

  return (
    <div className="homePage">

  


  
      <div className="bhoomiBannerad">
          <ImageSlider 
              images={[
                { image: img008, title: "Builder Floors", description: "Get Latest Inventories of Prominent Builders" },
                { image: img012, title: "Flats", description: "Buy and Sell your Old Flats at best possible prices" },
                { image: img026, title: "Houses", description: "Sell or Collaborate, your Old Houses with Prominent Builders" },
                { image: img030, title: "Commercials", description: "Sell and Lease Retail Showrooms, Shopes, Offices" },
                // { image: img035, title: "Farms", description: "Another description" },
                // { image: img036, title: "Slide 2", description: "Another description" },
                // { image: img040, title: "Slide 2", description: "Another description" },
                // { image: img045, title: "Slide 2", description: "Another description" },
                // { image: img047, title: "Slide 2", description: "Another description" },

              ]}
              duration={3000}
              titleStyle="text-sm font-semibold bg-black bg-opacity-60 px-3 py-1 rounded"
              descriptionStyle="text-xs bg-black bg-opacity-40 px-2 py-1 rounded"
              allowFade={true}
              showBullet={true}     // Correct prop name (from SliderComponent.jsx)
              showArrowIcons={false}
              containerWidth="100%" // Adjusted to fit the container
              containerHeight="300px"
              headflash={["Find your dream home", "Exclusive listings","Register Free","Nominal Subscription", "Hurry! Limited time offers","Seamleass User Experience"]}
              headflashstyle="custom-headflash"
              headflashduration={2000}
          />

      </div>

      <div className="bannerAds">
          <ImageSlider 
              images={[
                { image: space1, title: "", description: "" },
                { image: space2, title: "", description: "" },
                { image: space3, title: "", description: "" },
                { image: space4, title: "", description: "" },
                // { image: spacevideo, title: "", description: "" },
                
              ]}
              duration={3000}
              titleStyle="text-sm font-semibold bg-black bg-opacity-60 px-3 py-1 rounded"
              descriptionStyle="text-xs bg-black bg-opacity-40 px-2 py-1 rounded"
              allowFade={true}
              showBullet={false}     // Correct prop name (from SliderComponent.jsx)
              showArrowIcons={false}
              containerWidth="100%" // Adjusted to fit the container
              containerHeight="150px"
              headflash={[]}
              headflashstyle="custom-headflash"
              headflashduration={2000}
          />


      </div>





      
      <div className="textContainer">
        <div className="wrapper">
          {/* <h1 className="title">Buy Your Perfect Property</h1>
          <h2 className="title">List for Free.</h2>
          <h2>Showcase Your Masterpieces</h2>
            
          
          <p>
           The best upcoming portal, keeping interests of Buyers, Sellers and Builders, currently available in Delhi NCR and expanding to All Metro Cities pan India.
           
          </p> */}
          <div className="searchBox">
            <SearchBar /> 

          </div>
          <div className="boxes">
            <div className="box">
              <h1>16+</h1>
              <h2>Years of Experience</h2>
            </div>
            <div className="box">
              <h1>200+</h1>
              <h2>Experienced Agents</h2>
            </div>
            <div className="box">
              <h1>2000+</h1>
              <h2>Property Ready</h2>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="imgContainer">
        <img src={bg} alt="" />
      </div> */}

      <div className="myrow">
        {/* <h1>
          Why Bhoomi India Realtors?
        </h1>
        <p>
          We are a team of dedicated professionals with over 16 years of experience in the real estate industry. Our mission is to provide exceptional service and expertise to our clients, whether they are buying, selling, or renting properties. We pride ourselves on our commitment to integrity, transparency, and customer satisfaction. With a vast network and in-depth market knowledge, we strive to make every real estate transaction smooth and successful.
        </p>
        <p>
           Get direct access to Inventories of Prominent Builders

        </p>
        <h3>
          Our Mission: To empower individuals and families to achieve their real estate goals with confidence and ease.
        </h3>
        <p>
          We are providing you a platform to connect with the best builders and real estate professionals in the industry. Our goal is to simplify the process of buying, selling, or renting properties by offering a user-friendly interface, comprehensive listings, and expert guidance. Whether you are a first-time homebuyer or an experienced investor, we are here to help you navigate the real estate market with ease.
        </p> */}

        {/* <h3>
          Our Vision: 
        </h3>
        <p>
          To be the leading real estate agency in India, known for our innovative solutions and unparalleled customer service.
        </p>
         */}

      </div>


    </div>
  );
}

export default HomePage;
